import TheGrid from '@/views/dealers/dsr_codes/grid'

export default {
  path: '/dealers/dsr_codes',
  redirect: '/dealers/dsr_codes/index',
  name: 'dsrCodes',
  meta: {
    auth: {
      redirect: {
        name: 'dsrCodes.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Códigos DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'dsrCodes.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
